import React, { useState, useEffect } from 'react';

function Popup() {
    const [popupData, setPopupData] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [countdown, setCountdown] = useState(20);
    const [isTimeout, setIsTimeout] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    // Fetch popup on mount
    useEffect(() => {
        fetchPopupData();
    }, []);

    const fetchPopupData = async () => {
        try {
            const response = await fetch(`${API_URL}/popup/getActivePopup`);
            const result = await response.json();
            const data = result.data;

            if (data?.isActive) {
                const dismissedPopupId = localStorage.getItem('popupDismissedId');
                if (data.id.toString() !== dismissedPopupId) {
                    setPopupData(data);
                    setIsVisible(true);
                    setIsTimeout(data.isTimeout);
                    setCountdown(data.timeoutSeconds);
                }
            }
        } catch (error) {
            console.error('Error fetching popup data:', error);
        }
    };

    const handleDismiss = (action) => {
        setIsVisible(false);
        if (popupData) {
            localStorage.setItem('popupDismissedId', popupData.id);
        }
    };

    // Countdown logic
    useEffect(() => {
        if (!isVisible || !popupData || !isTimeout) return;

        if (countdown === 0) {
            handleDismiss('ok');
            return;
        }

        const timer = setTimeout(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [countdown, isVisible, popupData, isTimeout]);

    // Escape key close
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isVisible) {
                handleDismiss('cancel');
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isVisible]);

    // Click outside to close
    const handleBackdropClick = () => {
        handleDismiss('cancel');
    };

    if (!isVisible || !popupData) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300"
                onClick={handleBackdropClick}
            ></div>

            {/* Modal */}
            <div
                className="relative z-50 bg-white rounded-lg shadow-2xl max-w-md w-full mx-4 p-6 animate-fade-in"
                onClick={(e) => e.stopPropagation()} // stop click from closing modal
            >
                {/* Icon + Title */}
                <div className="flex items-center gap-3 mb-4">
                    <div className="flex-shrink-0 bg-myBlue text-myOrange rounded-full p-2">
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
                            />
                        </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-800">{popupData.title}</h3>
                </div>

                {/* Message */}
                <p className="text-gray-600 mb-2">{popupData.message}</p>

                {/* Buttons */}
                <div className="flex justify-end gap-3 mb-2">
                    <button
                        className="px-4 py-2 bg-myOrange text-white rounded-md hover:bg-myBlue transition"
                        onClick={() => handleDismiss('ok')}
                    >
                        Во ред
                    </button>
                </div>
                {isTimeout && <p className="text-sm text-gray-400">
                    Автоматско затворање за <span className="font-semibold">{countdown}</span> секунди...
                </p>}
            </div>
        </div>
    );
}

export default Popup